export type TableTranslations = {
  content: {
    button: {
      clear: string;
      search: string;
      tour: string;
    };
    maxRows: string;
    nextPage: string;
    noResults: string;
    of: string;
    previousPage: string;
  };
};

export const tableTranslations: TableTranslations = {
  content: {
    button: {
      clear: 'Clear',
      search: 'Search',
      tour: 'Help',
    },
    maxRows: 'Max rows',
    nextPage: 'Next page',
    noResults: 'No results',
    of: 'of',
    previousPage: 'Previous page',
  },
};
